import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Injector, ChangeDetectorRef, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './features/all-application/shared/loader/loader.component';// adjust path if needed
import { environment } from '../environments/environment';
import { FirebaseMessagingService } from './services/firebase-messaging.service';
import { NotificationService } from './services/notification.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CoreSocketService } from './core/service/core-socket/core-socket.service';
import { AuthenticationService } from './core/service/auth/authentication.service';
import { permissionEntity } from './core/constants/permission';
import { TruncatePipe } from './core/pipe/truncate.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomainConfigService } from './core/service/domainConfig/domain-config.service';
import { FavIconService } from './core/service/fav-icon/fav-icon.service';
import { LocalStorageService } from './core/service/localStorage/local-storage.service';
import { InternalChatService } from './core/service/internalChat/internal-chat.service';
import { InternalChatNotificationComponent } from './shared/internal-chat-notification/internal-chat-notification.component';
import { ProfileService } from './core/service/profile/profile.service';
import { ThemeService } from './core/service/theme/theme.service';
import { TmsSocketService } from './core/service/tms-socket/tms-socket.service';
import { AwayLockComponent } from './shared/away-lock/away-lock.component';
import { TMS_AWAY_OPTIONS, TMS_INACTIVITY_OPTION } from './core/constants/tms.const';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, CommonModule, TruncatePipe, InternalChatNotificationComponent, AwayLockComponent],
  template: `
    <app-loader></app-loader>
     <!-- Notification Banner -->
      <div 
        *ngIf="showNotificationBanner" 
        class="notification-banner"
        style="
          position: fixed; 
          top: 20px; 
          right: 20px; 
          background: #ff6c35; 
          color: white; 
          padding: 20px; 
          border-radius: 12px; 
          box-shadow: 0 4px 12px rgba(255, 108, 53, 0.3);
          z-index: 9999;
          max-width: 350px;
          font-family: Arial, sans-serif;
        ">
        
        <!-- Header -->
        <div style="display: flex; align-items: center; margin-bottom: 12px;">
          <span style="font-size: 24px; margin-right: 8px;">🔔</span>
          <strong style="font-size: 16px; font-weight: 600;">Enable Notifications</strong>
        </div>
        
        <!-- Message -->
        <p style="
          margin: 0 0 16px 0; 
          font-size: 14px; 
          line-height: 1.4; 
          opacity: 0.9;
        ">
          Stay updated with important alerts and messages
        </p>
        
        <!-- Buttons -->
        <div style="display: flex; gap: 8px;">
          <button 
            (click)="enableNotifications()" 
            style="
              flex: 1;
              padding: 10px 16px; 
              background: white; 
              color: #ff6c35; 
              border: none; 
              border-radius: 6px; 
              cursor: pointer;
              font-weight: 500;
              font-size: 14px;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='#f8f8f8'"
            onmouseout="this.style.background='white'">
            Enable
          </button>
          
          <button 
            (click)="dismissNotificationBanner()" 
            style="
              padding: 10px 16px; 
              background: transparent; 
              color: white; 
              border: 1.5px solid rgba(255, 255, 255, 0.7); 
              border-radius: 6px; 
              cursor: pointer;
              font-size: 14px;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='rgba(255, 255, 255, 0.1)'"
            onmouseout="this.style.background='transparent'">
            Later
          </button>
        </div>

        <!-- Add this fallback link -->
        <div style="margin-top: 10px; font-size: 12px;">
          <a 
            href="javascript:void(0)" 
            (click)="showManualInstructions()"
            style="color: white; text-decoration: underline;">
            Need help? Manual setup instructions
          </a>
        </div>
      </div>

    <!-- Socket Message Popup -->
    <div
      *ngIf="showSocketMessage"
      class="socket-message-popup"
      [@slideIn]>
      <div class="popup-header">
        <div class="header-left">
          <div class="d-flex">
            <!-- <span class="icon">💬</span> -->
            <strong
              class="sender-company text-nowrap"
            >
            {{
              socketMessageData?.senderCompany
                ? (socketMessageData.senderCompany | truncate: 30)?.text
                : socketMessageData?.senderId
            }}
            </strong>
          </div>
          <div class="d-block agent-div">
            <span class="agent-tenant">
              {{ socketMessageData?.agentTenant || socketMessageData?.tenant }}
            </span>
          </div>
        </div>
        <button class="close-btn" (click)="closeSocketMessage()">
          <span>✕</span>
        </button>
      </div>

      <div class="popup-body">
        <div class="message-content">
          <p class="message-text">{{ socketMessageContent }}</p>
        </div>
        @if (socketMessageData) {
        @if(socketMessageData?.senderName) {
        <h6 class="sender-name mb-0">
          {{
              socketMessageData?.senderName
                ? (socketMessageData.senderName | truncate: 20)?.text
                : socketMessageData?.senderId
            }}
        </h6>
        }
        <div class="message-meta">
          <span class="timestamp">{{ socketMessageTime }}</span>
        </div>
        }

      </div>

      <div class="popup-footer">
        <button class="btn-view" (click)="viewSocketMessage()">
          View Details
        </button>
        <button class="btn-dismiss" (click)="closeSocketMessage()">
          Dismiss
        </button>
      </div>
    </div>

    <router-outlet></router-outlet>

    <app-internal-chat-notification />

    <!-- Away-lock rendered as an overlay on top of the current page (not routed)
         so any in-progress form state on the underlying page survives lock/unlock -->
    <app-away-lock *ngIf="tmsSocketService.overlayVisible$ | async"></app-away-lock>
  `,
  styles: [`
    .socket-message-popup {
      position: fixed;
      top: 80px;
      right: 20px;
      width: 380px;
      background: linear-gradient(135deg, #ff6c35 0%, #ff8f6b 100%);
      border-radius: 16px;
      box-shadow: 0 10px 40px rgba(255, 108, 53, 0.3);
      z-index: 10000;
      overflow: hidden;
      animation: slideInRight 0.3s ease-out;
    }

    @keyframes slideInRight {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .header-left {
      display: block;
      align-items: center;
      gap: 10px;
      color: white;
    }

    .header-left .icon {
      font-size: 24px;
      animation: bounce 1s infinite;
    }

    @keyframes bounce {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-5px); }
    }

    .header-left strong {
      font-size: 16px;
      font-weight: 600;
    }

    .header-left .agent-tenant {
      font-size: 14px;
      font-weight: 600;
    }

    .close-btn {
      background: rgba(255, 255, 255, 0.2);
      border: none;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 18px;
      transition: all 0.2s;
    }

    .close-btn:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: rotate(90deg);
    }

    .popup-body {
      padding: 20px;
      color: white;
    }

    .message-content {
      margin-bottom: 12px;
    }

    .message-text {
      margin: 0;
      font-size: 14px;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.95);
    }

    .message-meta {
      display: flex;
      justify-content: flex-end;
    }

    .sender-name {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      font-style: italic;
      text-align: end;
    }

    .timestamp {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      font-style: italic;
    }

    .popup-footer {
      display: flex;
      gap: 10px;
      padding: 16px 20px;
      background: rgba(0, 0, 0, 0.1);
    }

    .popup-footer button {
      flex: 1;
      padding: 10px 16px;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
    }

    .btn-view {
      background: white;
      color: #ff6c35;
    }

    .btn-view:hover {
      background: #f8f9fa;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .btn-dismiss {
      background: rgba(255, 255, 255, 0.2);
      color: white;
      border: 1px solid rgba(255, 255, 255, 0.3);
    }

    .btn-dismiss:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    @media (max-width: 768px) {
      .socket-message-popup {
        width: calc(100% - 40px);
        right: 20px;
        left: 20px;
      }
    }
  `],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'crizac-admin-dashboard';
  production = environment?.production;
  showNotificationBanner = false;
  unreadCount = 0;
  private profileService = inject(ProfileService);
  private themeService = inject(ThemeService); 
  // Socket message popup state
  showSocketMessage = false;
  socketMessageContent = '';
  socketMessageData: any = null;
  socketMessageTime = '';
  private messageTimeout: any;
  loggedInUser: any;
  userDetailsData: any = null;

  private destroy$ = new Subject<void>();
  private firebaseMessaging?: FirebaseMessagingService;
  private notificationService?: NotificationService;
  private isBrowser: boolean;
  private bannerShownThisSession = false;

  private domainConfigService = inject(DomainConfigService);
  private faviconService = inject(FavIconService);
  private _localStorageService = inject(LocalStorageService);
  private readonly internalChatService  = inject(InternalChatService);
  readonly tmsSocketService = inject(TmsSocketService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private injector: Injector,
    private socketService: CoreSocketService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private authService: AuthenticationService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    // if (this.production) {
    //   console.log = function () { };
    // }

    if (!isLocalhost) {
      console.log = function () { };
    }

    // Only inject services in browser
    if (this.isBrowser) {
      this.firebaseMessaging = this.injector.get(FirebaseMessagingService);
      this.notificationService = this.injector.get(NotificationService);
    }

    this.loadCurrentUser().then(() => {
      const token = this._localStorageService.getKey('access_token') || this.loggedInUser?.token || '';
      this.internalChatService.initSocket(token, this.loggedInUser?.id);
    })
  }

  async ngOnInit(): Promise<void> {
    this.themeService.init();
    this.setupDomainSpecificAssets();
    this.guardAgainstNavigationWhileLocked();
    this.listenForTmsLockEvents();

    const permissions = await this.authService.getPermissions();
    const hasSupportChat = permissions?.some((p: any) => p.module.toLowerCase() === permissionEntity.modules.support_chat.toLowerCase());
    const hasCoventrySupportChat = permissions?.some((p: any) => p.module.toLowerCase() === permissionEntity.modules.coventry_support_chat.toLowerCase());

    this.getUserId();

    if (hasSupportChat) {
      this.initializeNotifications();
      this.setupNotificationListeners();
      this.checkNotificationPermission();
      this.subscribeToSocket();
      this.serviceWorkerPushNotNavigation();
    }

    if (hasCoventrySupportChat) {
      this.subscribeToSocket();
      this.serviceWorkerPushNotNavigation();
    }

    this.tmsSocketService.connect();
  }

  ngOnDestroy(): void {
    this._disableBackButtonTrap();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _backButtonTrapListener: (() => void) | null = null;

  /**
   * The away-lock overlay blocks pointer interaction with the page underneath,
   * but it can't stop the browser's own back/forward buttons — those fire a
   * popstate event that Angular Router will happily act on behind the overlay,
   * swapping the route the user unlocks into.
   *
   * Reacting to the resulting NavigationStart and steering back via
   * router.navigateByUrl() is a race: if the user presses back twice in quick
   * succession, the second popstate cancels our in-flight corrective
   * navigation before it settles, and the second press gets through. Instead
   * we trap at the History API level — push a duplicate entry so the first
   * back/forward press is absorbed locally, and re-push on every subsequent
   * popstate while still locked so the real history never becomes reachable.
   */
  private guardAgainstNavigationWhileLocked(): void {
    this.tmsSocketService.overlayVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe(visible => (visible ? this._enableBackButtonTrap() : this._disableBackButtonTrap()));
  }

  private _enableBackButtonTrap(): void {
    if (this._backButtonTrapListener) return;
    history.pushState(null, '', location.href);
    this._backButtonTrapListener = () => {
      if (this.tmsSocketService.isLocked) {
        history.pushState(null, '', location.href);
      }
    };
    window.addEventListener('popstate', this._backButtonTrapListener);
  }

  private _disableBackButtonTrap(): void {
    if (this._backButtonTrapListener) {
      window.removeEventListener('popstate', this._backButtonTrapListener);
      this._backButtonTrapListener = null;
    }
  }

  /**
   * Bridges tms:lock events (server push or another tab locking) to the
   * away-lock overlay. Lives here — not in HeaderComponent — because this
   * component is always mounted; HeaderComponent is only alive while a
   * dashboard route is active, so a lock signal arriving while a tab is
   * elsewhere (or mid-navigation) would otherwise be silently dropped.
   */
  private listenForTmsLockEvents(): void {
    this.tmsSocketService.lockEvent$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lockEvent => {
        if (!lockEvent) return;
        const awayOption = TMS_AWAY_OPTIONS.find(o => o.key === lockEvent.breakType)
          ?? (lockEvent.breakType === TMS_INACTIVITY_OPTION.key ? TMS_INACTIVITY_OPTION : null)
          ?? {
            key: lockEvent.breakType,
            label: lockEvent.breakType,
            icon: 'schedule',
            color: '#FF6525',
          };
        this.tmsSocketService.saveAwayOption(awayOption);
        this.tmsSocketService.showLockOverlay();
      });
  }

  /**
  * Initialize Firebase messaging and notification services
  */
  private async initializeNotifications(): Promise<void> {
    if (!this.isBrowser || !this.firebaseMessaging) return;

    try {

      // Check if notifications are supported
      if (!this.firebaseMessaging!.isNotificationSupported()) {
        return;
      }

      // Check if user already interacted with banner this session or permanently
      const bannerInteracted = sessionStorage.getItem('notification_banner_shown')
        || localStorage.getItem('notification_banner_shown');

      // Check if user already has a token
      const existingToken = this.firebaseMessaging!.getStoredToken();
      if (!existingToken) {
        // Only show banner if permission hasn't been decided and user hasn't interacted with it
        const permission = this.firebaseMessaging!.getPermissionStatus();
        if (permission === 'default' && bannerInteracted !== 'true' && !this.bannerShownThisSession) {
          this.showNotificationBanner = true;
          this.bannerShownThisSession = true;
        }
      } else {
        // User already has notifications enabled, just refresh the token
        await this.firebaseMessaging!.requestPermissionAndGetToken();
      }

    } catch (error) {
      console.error('Error initializing notifications:', error);
    }
  }

  /**
   * Setup listeners for incoming messages and unread count
   */
  private setupNotificationListeners(): void {
    if (!this.isBrowser || !this.firebaseMessaging || !this.notificationService) return;

    // Listen for FCM messages
    this.firebaseMessaging!.getMessage()
      .pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        if (payload) {
          // Add to notification service
          this.notificationService!.addNotification(payload);
        }
      });

    // Listen for unread count changes
    this.notificationService!.getUnreadCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadCount = count;
      });

    // Listen for FCM token changes
    this.firebaseMessaging!.getToken()
      .pipe(takeUntil(this.destroy$))
      .subscribe(token => {
        if (token) {
          // Send token to your backend server
          this.firebaseMessaging!.sendTokenToServer(token);
        }
      });
  }

  /**
   * Check current notification permission and show banner if needed
   */
  private checkNotificationPermission(): void {
    if (!this.isBrowser && !this.firebaseMessaging) return;

    const permission = this.firebaseMessaging!.getPermissionStatus();

    // Check if user has already interacted with banner this session or permanently
    const bannerInteracted = sessionStorage.getItem('notification_banner_shown')
      || localStorage.getItem('notification_banner_shown');

    // Only show banner if:
    // 1. Permission is still 'default' (not asked yet)
    // 2. User hasn't interacted with banner before
    // 3. Banner hasn't been shown already in this component instance
    if (permission === 'default' && bannerInteracted !== 'true' && !this.bannerShownThisSession) {
      this.showNotificationBanner = true;
      this.bannerShownThisSession = true;
    } else {
      console.log('❌ Not showing banner - conditions not met');
    }
  }

  /**
   * Enable notifications when user clicks the button
   */
  async enableNotifications(): Promise<void> {
    if (!this.isBrowser || !this.firebaseMessaging) return;

    // Hide banner immediately when clicked
    this.showNotificationBanner = false;
    sessionStorage.setItem('notification_banner_shown', 'true');
    localStorage.setItem('notification_banner_shown', 'true');

    try {
      // Add timeout to permission request
      const permission = await Promise.race([
        Notification.requestPermission(),
        new Promise((resolve) => setTimeout(() => resolve('timeout'), 5000))
      ]);


      if (permission === 'timeout') {
        this.showErrorMessage('Permission request timed out. Please enable notifications manually in your browser settings.');
        return;
      }

      if (permission !== 'granted') {
        this.showErrorMessage(`Permission ${permission}. Please allow notifications in your browser settings.`);
        return;
      }

      // Permission granted, get FCM token
      const token = await this.firebaseMessaging!.requestPermissionAndGetToken();

      if (token) {
        this.showSuccessMessage('Notifications enabled successfully!');
      } else {
        this.showErrorMessage('Failed to get notification token.');
      }

    } catch (error: any) {
      this.showErrorMessage(`Error: ${error.message || 'Unknown error'}`);
    }
  }
  /**
   * Dismiss notification banner
   */
  dismissNotificationBanner(): void {
    this.showNotificationBanner = false;
    // Remember user's choice permanently
    sessionStorage.setItem('notification_banner_shown', 'true');
    localStorage.setItem('notification_banner_shown', 'true');
  }

  /**
   * Show success message (implement with your preferred notification library)
   */
  private showSuccessMessage(message: string): void {
    // Implement with your preferred toast/snackbar library

    // Simple browser alert for now - replace with proper UI component
    if (!this.production) {
      alert(message);
    }
  }

  /**
   * Show error message (implement with your preferred notification library)
   */
  private showErrorMessage(message: string): void {
    // Implement with your preferred toast/snackbar library

    // Simple browser alert for now - replace with proper UI component
    if (!this.production) {
      alert(message);
    }
  }

  showManualInstructions(): void {
    alert(`Manual Setup Instructions:

    1. Click the 🔒 lock icon in your browser address bar
    2. Select "Allow" for Notifications
    3. Refresh the page and try again

    OR

    Chrome: Settings > Privacy > Site Settings > Notifications > Allow
    Firefox: Settings > Privacy & Security > Permissions > Notifications > Allow`);
  }

  private async subscribeToSocket() {
    if (!this.isBrowser) return;

    const userDetails = await this._localStorageService.getKeyIndexedDbKey(
      'currentUser'
    );

    this.socketService.connect();
    this.socketService.onMessageUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe((msg: any) => {
        if (
          !msg?.isAgentReply &&
          !this.router.url.includes('/dashboard/chat-master/all-chats-whatsapp') &&
          this.authService.isLoggedIn() &&
          userDetails?.whatsAppNotification &&
          userDetails?.roles[0]?.id !== '76'
        ) {
          this.showSocketMessagePopup(msg);
        }
      });
  }

  /**
   * Show socket message popup
   */
  private showSocketMessagePopup(message: any): void {
    // Extract message content based on your message structure
    this.socketMessageContent = message?.text || message?.content || message?.message || 'New message received';
    this.socketMessageData = message;
    this.socketMessageTime = new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });

    // Clear any existing timeout
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }

    // Force reset to trigger animation
    this.showSocketMessage = false;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.showSocketMessage = true;
      this.cdr.detectChanges();

      // Auto-hide after 10 seconds
      this.messageTimeout = setTimeout(() => {
        this.closeSocketMessage();
      }, 10000);
    }, 100);
  }

  /**
   * Close socket message popup
   */
  closeSocketMessage(): void {
    this.showSocketMessage = false;
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
      this.messageTimeout = null;
    }
    this.cdr.detectChanges();
  }

  /**
   * View socket message details
   */
  viewSocketMessage(): void {
    // Close the popup
    this.closeSocketMessage();

    // Navigate to WhatsApp inbox
    this.router.navigate(['/dashboard/chat-master/all-chats-whatsapp'], {
      queryParams: {
        type: 'widget',
        id: this.socketMessageData?.conversationId
      }
    });

    if (this.socketMessageData?.platformType === 'whatsappChat') {
      this.router.navigate(['/dashboard/chat-master/all-chats-whatsapp'], {
        queryParams: {
          type: 'widget',
          id: this.socketMessageData?.conversationId
        }
      });
    } else if (this.socketMessageData?.platformType === 'coventryChat') {
      this.router.navigate(['/dashboard/chat-master/coventry-chat'], {
        queryParams: {
          type: 'widget',
          id: this.socketMessageData?.conversationId
        }
      });
    }
  }

  /**
 * Setup domain-specific favicon and title
 */
  private setupDomainSpecificAssets(): void {
    const config = this.domainConfigService.getCurrentDomainConfig();

    // Set favicon
    if (config.favicon) {
      this.faviconService.setFavicon(config.favicon);
    }

    // Set page title
    if (config.title) {
      this.faviconService.setTitle(config.title);
    }

    // Optional: Add domain-specific class to body for styling
    // this.addDomainClassToBody(config.domain);
  }

  /**
  * Add domain-specific class to body for CSS customization
  */
  private addDomainClassToBody(domain: string): void {
    const cleanDomain = domain.replace(/\./g, '-');
    document.body.classList.add(`domain-${cleanDomain}`);
  }

  serviceWorkerPushNotNavigation() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('[Angular] Received message from SW:', event.data);

        if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
          const url = event.data.url;
          console.log('[Angular] Navigating to:', url);

          // Navigate to the URL
          this.router.navigateByUrl(url);

          // Optional: You can also access other data
          // const conversationId = event.data.data?.conversationId;
          // const platformType = event.data.data?.platformType;
        }
      });
    }
  }

  private async loadCurrentUser() {
    const switchUser = JSON.parse(this._localStorageService.getKey('isSwitchUser') || 'false');
    this.loggedInUser = await this._localStorageService.getKeyIndexedDbKey(switchUser ? 'switchUser' : 'currentUser');
  }

  private async getUserId(){
    const userDetails = await this._localStorageService.getKeyIndexedDbKey(
      'currentUser'
    );
   
    if (userDetails?.id) {
      this.getUserDetails(userDetails?.id).subscribe({
        next: (userRes: any) => {
          this.userDetailsData = userRes?.data?.[0] || userRes?.data;
          if(!this.userDetailsData?.userDetails?.timezone){
            this.authService.setTImezone();
          }
        },
        error: (err: any) => {
          console.error('Error fetching user details:', err);
        }
      });
    }

  }

  getUserDetails(userId: string | number) {
    return this.profileService.getUserDetailsById(userId);
  }

}